import React from "react";
import { Button } from "@mui/material";

export default function DisableBlueSmallButton({ startIcon, buttonTitle, onClick ,width, disabled, height , endIcon,fontSize}) {
  return (
    <Button
      variant="contained"
      disabled={disabled}
      startIcon={startIcon ? startIcon : ""}
      onClick={onClick}
      endIcon={endIcon}
      sx={{
        borderRadius: "6px",

        fontSize: fontSize?fontSize : "14px",
        fontWeight: 700,
        textTransform: "none",
        backgroundColor: "#572575",
        width: width?width :null ,
        height :height ?height :null,
        px: 3,
        opacity:'20%',
        "&:hover": {
          backgroundColor: "#572575",
        },
      }}
    >
      {buttonTitle}
    </Button>
  );
}
